import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

/* eslint-disable jsx-a11y/media-has-caption */
import React from 'react';
import classNames from 'classnames';
import MediaQuery from 'react-responsive';
import cloudinaryVideoUrl, { DEVICE_TYPE } from '@scentregroup/ui/tools/cloudinary/video';
import { ratioOptions, getImageHeight } from '@scentregroup/ui/tools/cloudinary/image';
import LazyLoad from 'react-lazyload';
import style from '../responsive-asset/index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HAVE_CURRENT_DATA = 2; // https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/readyState

export class RawResponsiveVideo extends React.Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "onLoad", event => {
      if (this.props.onLoad) {
        this.props.onLoad(event);
      }
    });

    _defineProperty(this, "onError", event => {
      if (this.props.onError) {
        this.props.onError(event);
      }
    });

    this.videoNode = /*#__PURE__*/React.createRef();
  }

  componentDidMount() {
    // Make sure onLoad is still fired if the video was already loaded via SSR
    if (this.videoNode.current && this.videoNode.current.readyState >= HAVE_CURRENT_DATA) {
      this.onLoad();
    }
  }

  render() {
    const {
      className,
      videoUrl,
      mobileRatio = 'standard',
      desktopRatio = 'standard',
      numberOfItems = 1,
      lazyLoad,
      dataTestId
    } = this.props;

    const videoContent = /*#__PURE__*/_jsx("div", {
      className: classNames(style.ResponsiveAsset, className, style["desktopRatio_".concat(desktopRatio)], style["mobileRatio_".concat(mobileRatio)]),
      "data-id": "responsive-video_index_videoContent_div",
      children: /*#__PURE__*/_jsxs("video", {
        playsInline: true,
        autoPlay: true,
        loop: true,
        muted: true,
        controls: false,
        className: style.ResponsiveAsset,
        ref: this.videoNode,
        "data-test-id": dataTestId,
        onLoadedData: this.onLoad,
        onError: this.onError,
        "data-id": "responsive-video_index_videoContent_div_video",
        children: [/*#__PURE__*/_jsx(MediaQuery, {
          query: "(max-width: 767px)",
          "data-id": "responsive-video_index_videoContent_video_MediaQuery",
          children: /*#__PURE__*/_jsx("source", {
            type: "video/mp4",
            src: cloudinaryVideoUrl({
              contentfulUrl: videoUrl,
              deviceType: DEVICE_TYPE.mobile,
              removeAudio: true
            }),
            "data-id": "responsive-video_index_videoContent_MediaQuery_source"
          })
        }), /*#__PURE__*/_jsx(MediaQuery, {
          query: "(min-width: 768px)",
          "data-id": "responsive-video_index_videoContent_video_MediaQuery",
          children: /*#__PURE__*/_jsx("source", {
            type: "video/mp4",
            src: cloudinaryVideoUrl({
              contentfulUrl: videoUrl,
              deviceType: DEVICE_TYPE.desktop,
              removeAudio: true
            }),
            "data-id": "responsive-video_index_videoContent_MediaQuery_source"
          })
        })]
      })
    });

    return lazyLoad ? /*#__PURE__*/_jsx(LazyLoad, {
      offset: 800,
      height: getImageHeight({
        ratio: mobileRatio,
        numberOfItems
      }),
      "data-id": "responsive-video_index_videoContent_LazyLoad",
      children: videoContent
    }) : videoContent;
  }

}
RawResponsiveVideo.defaultProps = {
  numberOfItems: 1
};
export default RawResponsiveVideo;